import React, { useState } from 'react';
import { getUILoc } from '../utils/cardUtils.js';
import '../App.css';

const NumberInput = ({ prompt, min, max, onConfirm, isClosing }) => {
    const [value, setValue] = useState(min);

    const handleIncrement = () => {
        setValue(prev => Math.min(max, prev + 1));
    };

    const handleDecrement = () => {
        setValue(prev => Math.max(min, prev - 1));
    };

    const handleChange = (e) => {
        const num = parseInt(e.target.value, 10);
        if (isNaN(num)) {
            setValue(min);
        } else {
            setValue(Math.max(min, Math.min(max, num)));
        }
    };

    const handleConfirm = () => {
        onConfirm(value);
    };

    return (
        <div className={`choice-prompt-overlay ${isClosing ? 'closing' : ''}`}>
            <div className={`choice-prompt ${isClosing ? 'closing' : ''}`}>
                <h3>{prompt}</h3>
                <div className="number-input-container">
                    <button onClick={handleDecrement}>-</button>
                    <input 
                        type="number" 
                        value={value} 
                        onChange={handleChange} 
                        min={min} 
                        max={max} 
                    />
                    <button onClick={handleIncrement}>+</button>
                </div>
                <button onClick={handleConfirm} className="confirm-button">
                    {getUILoc('BUTTONS.CONFIRM')}
                </button>
            </div>
        </div>
    );
};

export default NumberInput;
